import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/authuntication/auth-service/login.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  isLogin: boolean = false;
  role: any;
  admin: any;
  admin_content: any;
  developer: any;
  marketer: any;

  constructor(private _AuthService: LoginService, private _router: Router) {
    this.getCurrentUser();
    this.userData();
    this.currentUserIsLogin();
  }

  ngOnInit(): void { }

  getCurrentUser() {
    if (this._AuthService.currentUser != null) {
      this.isLogin = true;
    }
    else {
      this.isLogin = false;
    }
  }

  currentUserIsLogin() {
    this._AuthService.currentUser.subscribe(() => {
      if (this._AuthService.currentUser.getValue() != null) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    });
  }

  userData() {
    if (this._AuthService.userData.sub.role === "super_admin") {
      this.role = true;
      this.admin_content = true;
      this.admin = true;
      this.developer = true;
      this.marketer = true;
    }
    else if (this._AuthService.userData.sub.role === "admin_content") {
      this.admin_content = true;
      this.role = false;
      this.admin = false;
      this.marketer = false;
      this.developer = false;
    } else if (this._AuthService.userData.sub.role === "admin") {
      this.admin = true;
      this.admin_content = false;
      this.role = false;
      this.developer = false;
      this.marketer = false;
    } else if (this._AuthService.userData.sub.role === "developer") {
      this.developer = true
      this.role = false;
      this.admin_content = false;
      this.admin = false;
      this.marketer = false;
    } else if (this._AuthService.userData.sub.role === "marketer") {
      this.marketer = true;
      this.role = false;
      this.admin_content = false;
      this.admin = false;
      this.developer = false;
    }
    else {
      this.role = false;

    }
  }

}